import ConfigureAppEnvironment from './environment';

export default ConfigureAppEnvironment();
